import { render, staticRenderFns } from "./procurementBiddingList.vue?vue&type=template&id=a11ea4da&scoped=true"
import script from "./procurementBiddingList.vue?vue&type=script&lang=js"
export * from "./procurementBiddingList.vue?vue&type=script&lang=js"
import style0 from "./procurementBiddingList.vue?vue&type=style&index=0&id=a11ea4da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11ea4da",
  null
  
)

export default component.exports